let wompiBaseUrl, redirectBaseUrl, wompiPublicKey, epaycoBaseUrl, epaycoIsTest, epaycoPKey, epaycoPrivateKey, epaycoPublicKey;

if (process.env.NODE_ENV === 'production') {
  // Production

  wompiBaseUrl = 'https://production.wompi.co/v1';
  redirectBaseUrl = 'https://cemex.nibi.com.co';
  wompiPublicKey = 'pub_prod_NLBmnw3o3NeUau4bTvvi4NpzjprGTnOf';
  epaycoBaseUrl = "https://apify.epayco.co";
  epaycoIsTest = false;

} else {
  // Sandbox.

  wompiBaseUrl = 'https://sandbox.wompi.co/v1';
  redirectBaseUrl = 'http://localhost:3000';
  wompiPublicKey = 'pub_test_GtPKxnAUw1cMxUy4mKn1kTcojKzbxix1';
  epaycoBaseUrl = "https://apify.epayco.co";
  epaycoIsTest = true;
}
epaycoPKey = "a509574192e94aad063cc89160f43a3213a1334c";
epaycoPublicKey = "b1318567d307651240f02fc5a8942dda";
epaycoPrivateKey = "a161463c393b690ae2612705b95306d8";
let pciVaultUrl = "https://api.pcivault.io/v1";
let pciVaultUser = "Nibi";
let pciVaultPassword = "YEv#MT36hD";
let pciVaultPassphrase = "PRVS9H-eLU8fDMFtGXPbWlJJmgz_4oSz";

export { wompiBaseUrl, redirectBaseUrl, wompiPublicKey, epaycoBaseUrl, epaycoIsTest, epaycoPKey, epaycoPrivateKey, epaycoPublicKey, pciVaultUrl, pciVaultUser, pciVaultPassword, pciVaultPassphrase };
